import { render, staticRenderFns } from "./selectDepartment.vue?vue&type=template&id=6cfd96ba&"
import script from "./selectDepartment.vue?vue&type=script&lang=ts&"
export * from "./selectDepartment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports